<template>
  <div :class="{'content-wrappper': !finalReview}">
    <div class="view-details-main  p-relative h-100">
      <div class="d-flex view-record-header" v-if="!finalReview">
        <div @click="goBack()" class="cursor-pointer">
          <img src="/static/images/icons/LeftChevron.svg" alt="" />
        </div>
        <div class="certificate-heading text-ellipsis ">
          <span class="fw-400 font-24 product_name "> <span v-if="registrationDetails.product_name" :title="registrationDetails.product_name">{{ registrationDetails.product_name }}</span><span v-else>{{$t('NA')}}</span> </span>
          <p class="m-0 product_name pt-10 text-ellipsis"><span class="fw-400 font-18">(</span><span class="fw-700 font-18">{{
            $t('certificateNumber') }}: </span><span class="fw-400 font-18"
              v-if="registrationDetails.submission_number" :title="registrationDetails.submission_number">{{ registrationDetails.submission_number }}</span> <span
              class="fw-400 font-18" v-else>{{$t('NA')}}</span> <span class="fw-400 font-18">)</span> </p>
        </div>
      </div>
      <div class="row m-0  cards-main p-40">
        <div class="col-xs-12 p-0 status-card">
          <div class="d-flex col-gap-12">
            <div>
               <img v-if="registrationDetails.save_draft"
                src="/static/images/icons/draft.svg" class="save" />
              <img v-else-if="registrationDetails.status === 'active' && !registrationDetails.save_draft " src="/static/images/icons/green_check_icon.svg"
                class="save" />
              <img v-else-if="registrationDetails.status === 'expired'" src="/static/images/icons/ul-error-icon.svg"
                class="save" />
              <img v-else-if="registrationDetails.status === 'expiring soon' || registrationDetails.status === 'action needed'" src="/static/images/icons/ul_warning.svg"
                class="save" />
              <img v-else-if="registrationDetails.status === 'pending'" src="/static/images/icons/pending_icon.svg"
                class="save" />
            </div>
            <div class="product_name">
               <span class="status-font text-capitalize" v-if="registrationDetails.save_draft">{{ $t('status') }}: {{ translateStatus('draft') }}</span>
               <span class="status-font text-capitalize" v-else-if="registrationDetails.is_archived">{{ $t('status') }}: {{ translateStatus('archived') }}</span>
              <span class="status-font text-capitalize" v-else >{{ $t('status') }}: {{ translateStatus(registrationDetails.status) }}</span>
              <p class="m-0 fw-400 font-16" v-if="registrationDetails.save_draft">{{ $t('draftCertfficate') }} </p>
              <p class="m-0 fw-400 font-16" v-else-if="registrationDetails.status === 'active' && !registrationDetails.save_draft">{{ $t('activeCertificateNote') }} </p>
              <p class="m-0 fw-400 font-16" v-else-if="registrationDetails.status === 'expired'">{{ $t('expireCertificateNote') }} </p>
              <p class="m-0 fw-400 font-16" v-else-if="registrationDetails.status === 'expiring soon'">{{
                $t('expiringSoonCertificateNote') }} </p>
              <p class="m-0 fw-400 font-16" v-else-if="registrationDetails.status === 'pending'">{{ $t('pendingCertificate') }} </p>
               <p class="m-0 fw-400 font-16" v-else-if="registrationDetails.status === 'action needed'">{{ $t('actionNeededCertificate') }} </p>
            </div>
          </div>
        </div>
        <div class="col-xs-12 p-0 product-details" v-if="productDetails.length && certificateDetails.length">
          <DefaultULReview :downloadBtn="true && roleId !== roleInfo['RA Admin']" :certificateDetails="certificateDetails" :productDetails="productDetails" :finalReview="finalReview"
            @downloadEvidence="showDownloadPopup" :filesArray="fileArrayObject" :componentType="componentType"
            :registrationId="Number(regId)" :isNewToMarket="registrationDetails.isNewToMarket" :uploadBtn="false" :activeTab=1 :key="registrationDetails.isNewToMarket" :displayMaintenanceDocuments="registrationDetails.maintenance_attachments&&registrationDetails.maintenance_attachments.length?true:false"/>
        </div>
      </div>
      <consolidate-popup :title1="$t('consolidateEvidence')" :confirmationText1="confirmationText1"
        @download="downloadZip" @email="emailZip"></consolidate-popup>
      <loader :loadingStatus="loaderStatus"></loader>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import moment from 'moment';
import FileSaver from 'file-saver';
import EventBus from '../../utils/event-bus';
import { getRegistrationDetailsById } from '../../apis/registrations';
import { downloadEvidencesZip, getToDoListDetails, emailEvidencesZip } from '../../apis/ToDoList';
import { downloadFile } from '../../apis/fileUploadDownload';
import DefaultULReview from '../Common/DefaultULReview.vue';
import ConsolidatePopup from '../Common/ConsolidatePopup.vue';
import Loader from '../UIComponents/Loader.vue';

export default {
  components: {
    DefaultULReview,
    ConsolidatePopup,
    Loader
  },
  props: {
    roleId: Number,
    roleInfo: Object,
    finalReview: Boolean,
    nextBtn: String
  },
  watch: {
    nextBtn() {
      if (this.nextBtn === 'final') {
        this.$emit('submit');
        this.$router.push('/layout/registration');
      }
    },
  },
  data() {
    return {
      status: 'Expiring soon',
      regId: '',
      registrationDetails: {},
      certificateDetails: [],
      productDetails: [],
      all_attachments: [],
      test_report_array: [],
      product_certificate_array: [],
      barcode_array: [],
      maintenance_documents: [],
      componentType: { type: 'view-record', status: '' },
      loaderStatus: false,
      confirmationText1: '',
      fileArrayObject: {
        // eslint-disable-next-line quote-props
        'Test Reports': [], 'Product Certificates': [], 'Barcodes': [], 'Maintenance Documents': []
      },
      loggedInUser: '',
    };
  },
  created() {
    EventBus.$on('updateLanguage', (language, oldLanguage) => {
      if (language !== oldLanguage) {
        this.$router.go();
      }
    });
    this.loggedInUser = JSON.parse(localStorage.getItem('userData'));
  },
  async mounted() {
    if (this.$route.params.id) {
      this.regId = this.$route.params.id;
      await this.getToDoListDetails();
      await this.getRegistrationDetails();
    }
  },
  methods: {
    translateMessage(value) {
      // eslint-disable-next-line no-nested-ternary
      return value ? this.$t('Yes') : value === false ? this.$t('No') : '-';
    },
    goBack() {
      // eslint-disable-next-line no-unused-expressions
      this.$route.query.type === 'notifications' ? this.$router.push({ path: '/layout/alert' }) : this.$router.push({ path: '/layout/registration' });
    },
    async downloadFile(file) {
      await downloadFile(this.registrationId, file);
    },
    showDownloadPopup() {
      if (this.$i18n.locale === 'Portuguese') this.confirmationText1 = 'A Consolidação das Evidências está concluída, gostaria de fazer o Download?';
      else this.confirmationText1 = 'The Consolidation of Evidence is completed, would you like to Download it?';
      $('#consolidatePopup').modal('show');
    },
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },
    async getToDoListDetails() {
      this.loaderStatus = true;
      const response = await getToDoListDetails(this.regId);
      this.loaderStatus = false;
      this.componentType.status = response.status;
    },
    async downloadZip() {
      $('#consolidatePopup').modal('hide');
      this.loaderStatus = true;
      const data = { registration_ids: [Number(this.regId)] };
      const response = await downloadEvidencesZip(data);
      if (response) {
        const file = new Blob([response], {
          type: 'application/zip',
        });
        const fileName = this.$i18n.locale === 'Portuguese' ? `consolidate_${moment(new Date()).format('DD_MM_YYYY')}` : `consolidate_${moment(new Date()).format('MM_DD_YYYY')}`;
        FileSaver.saveAs(file, fileName);
        this.loaderStatus = false;
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: this.$i18n.locale === 'Portuguese' ? 'ZIP baixado com sucesso' : 'Downloaded zip successfully!',
          group: 'custom-notification',
        });
      } else {
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Erro ao baixar o zip!' : 'Error while downloading zip!',
          group: 'custom-notification',
        });
      }
    },
    async emailZip() {
      $('#consolidatePopup').modal('hide');
      this.loaderStatus = true;
      const data = { registration_ids: [Number(this.regId)] };
      const response = await emailEvidencesZip(data);
      if (response) {
        this.loaderStatus = false;
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: this.$i18n.locale === 'Portuguese' ? 'Zip enviado por e-mail com sucesso' : 'Emailed zip successfully!',
          group: 'custom-notification',
        });
      } else {
        this.loaderStatus = false;
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Erro ao enviar o zip por e-mail!' : 'Error while emailing zip!',
          group: 'custom-notification',
        });
      }
    },
    translateStatus(status) {
      if (this.$i18n.locale === 'Portuguese') {
        // eslint-disable-next-line no-nested-ternary
        status = status === 'expiring soon' ? 'Expiring_soon' : status === 'action needed' ? 'action_needed' : status;
        const data = {
          active: 'Ativo',
          expired: 'Expirado',
          Expiring_soon: 'Expirando em breve',
          pending: 'Pendente',
          draft: 'Rascunho',
          action_needed: 'Ação necessária',
          archived: 'Arquivado'
        };
        return data[status];
      }
      return status ? status.charAt(0).toUpperCase() + status.slice(1) : ' ';
    },
    async getRegistrationDetails() {
      this.loaderStatus = true;
      const response = await getRegistrationDetailsById(this.regId);
      this.registrationDetails = response;
      const id = response.registration_id;
      Object.keys(this.fileArrayObject).forEach((category) => {
        if (category === 'Test Reports') this.fileArrayObject[category] = response.test_report_attachments;
        if (category === 'Product Certificates') this.fileArrayObject[category] = response.product_certificate_attachments;
        else if (category === 'Barcodes') this.fileArrayObject[category] = response.barcode_attachments;
        else if (category === 'Maintenance Documents') this.fileArrayObject[category] = response.maintenance_attachments;
      });
      if (response && !id) {
        this.loaderStatus = false;
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Registro não encontrado!' : 'Registration is not found!',
          group: 'custom-notification',
        });
      } else if (response) {
        this.loaderStatus = false;
        if (this.registrationDetails) {
          this.gridData = [];
          this.gridDataProgress = [];
          // let expiration = '';
          let expirationDate = '';
          let approvalDate = '';
          let submissionDate = '';
          let revisionDate = '';
          let nextMaintenanceDate = '';
          let countryName = '';
          if (this.registrationDetails.doesNotExpireStatus) {
            expirationDate = 'DNE';
          } else if (this.registrationDetails.expiration_date !== '' && this.registrationDetails.expiration_date !== null) {
            expirationDate = this.$i18n.locale === 'Portuguese' ? moment.utc(this.registrationDetails.expiration_date).format('DD/MM/YYYY') : moment.utc(this.registrationDetails.expiration_date).format('MM/DD/YYYY');
          } else {
            expirationDate = this.$i18n.locale === 'Portuguese' ? 'N/D' : 'N/A';
          }
          if (this.registrationDetails.approval_date !== '' && this.registrationDetails.approval_date !== null) {
            approvalDate = this.$i18n.locale === 'Portuguese' ? moment.utc(this.registrationDetails.approval_date).format('DD/MM/YYYY') : moment.utc(this.registrationDetails.approval_date).format('MM/DD/YYYY');
          } else {
            approvalDate = this.$i18n.locale === 'Portuguese' ? 'N/D' : 'N/A';
          }
          if (this.registrationDetails.submission_date !== '' && this.registrationDetails.submission_date !== null) {
            submissionDate = this.$i18n.locale === 'Portuguese' ? moment.utc(this.registrationDetails.submission_date).format('DD/MM/YYYY') : moment.utc(this.registrationDetails.submission_date).format('MM/DD/YYYY');
          } else {
            submissionDate = this.$i18n.locale === 'Portuguese' ? 'N/D' : 'N/A';
          }
          if (this.registrationDetails.product_family !== '' && this.registrationDetails.product_family !== null) {
            revisionDate = this.$i18n.locale === 'Portuguese' ? moment.utc(this.registrationDetails.product_family).format('DD/MM/YYYY') : moment.utc(this.registrationDetails.product_family).format('MM/DD/YYYY');
          } else {
            revisionDate = this.$i18n.locale === 'Portuguese' ? 'N/D' : 'N/A';
          }
          if (this.registrationDetails.next_maintenance_date !== '' && this.registrationDetails.next_maintenance_date !== null) {
            nextMaintenanceDate = this.$i18n.locale === 'Portuguese' ? moment.utc(this.registrationDetails.next_maintenance_date).format('DD/MM/YYYY') : moment.utc(this.registrationDetails.next_maintenance_date).format('MM/DD/YYYY');
          } else {
            nextMaintenanceDate = this.$i18n.locale === 'Portuguese' ? 'N/D' : 'N/A';
          }
          if (
            (this.registrationDetails.country_name === '' || this.registrationDetails.country_name === null) &&
            (this.registrationDetails.country_code === '' || this.registrationDetails.country_code === null)
          ) {
            countryName = this.$i18n.locale === 'Portuguese' ? 'Não disponível' : 'Not Available';
          } else {
            countryName = this.registrationDetails.country_name;
          }

          this.certificateDetails = [
            { id: 1, detailKey: this.$t('certificationNumber'), detailValue: this.registrationDetails.submission_number },
            { id: 2, detailKey: this.$t('certificationURLOpt'), detailValue: this.registrationDetails.registration_number },
            { id: 3, detailKey: this.$t('managedBy'), detailValue: this.registrationDetails.local_representative },
            { id: 4, detailKey: this.$t('accreditedBy'), detailValue: this.registrationDetails.issued_by },
            { id: 5, detailKey: this.$t('registrationDate'), detailValue: submissionDate },
            { id: 6, detailKey: this.$t('dateOfIssue'), detailValue: approvalDate },
            { id: 7, detailKey: this.$t('maintenanceDate'), detailValue: revisionDate },
            { id: 8, detailKey: this.$t('nextMaintenanceDate'), detailValue: nextMaintenanceDate },
            { id: 9, detailKey: this.$t('dateOfExpiration'), detailValue: expirationDate },
            { id: 10, detailKey: this.$t('alertDate'), detailValue: this.registrationDetails.alertBeforeMonths },
            { id: 11, detailKey: this.loggedInUser.company + this.$t('medcomContact'), detailValue: this.registrationDetails.medcomp_contact_name },
            { id: 12, detailKey: this.$t('standards'), detailValue: this.registrationDetails.standards },
            { id: 13, detailKey: this.$t('ordinance'), detailValue: this.registrationDetails.ordinance },
            { id: 14, detailKey: this.$t('importedProduct'), detailValue: this.translateMessage(this.registrationDetails.imported_product) },
            { id: 15, detailKey: this.$t('importer'), detailValue: this.registrationDetails.importer },
            { id: 16, detailKey: this.$t('requester'), detailValue: this.registrationDetails.requester },
            { id: 17, detailKey: this.$t('tradeRepresentative'), detailValue: this.registrationDetails.trade_representative },
            { id: 18, detailKey: this.$t('status'), detailValue: this.registrationDetails.inputStatus },
            { id: 19, detailKey: this.$t('comments'), detailValue: this.registrationDetails.comments }
          ];
          this.productDetails = [
            { id: 1, detailKey: this.$t('productName'), detailValue: this.registrationDetails.product_name },
            { id: 2, detailKey: this.$t('countryOfOrigin'), detailValue: countryName },
            { id: 3, detailKey: this.$t('productCategory'), detailValue: this.registrationDetails.registrationType },
            { id: 4, detailKey: this.$t('description'), detailValue: this.registrationDetails.configuration },
            // { id: 5, detailKey: this.$t('requirements'), detailValue: this.registrationDetails.configuration },
            // { id: 6, detailKey: this.$t('attachments'), detailValue: this.registrationDetails.configuration },
            { id: 7, detailKey: this.$t('manufacturer'), detailValue: this.registrationDetails.registrationCompany },
            { id: 8, detailKey: this.$t('ManufacturingAddress'), detailValue: this.registrationDetails.manufacturingAddress },
            { id: 9, detailKey: this.$t('barcode'), detailValue: this.registrationDetails.barcode },
            { id: 10, detailKey: this.$t('brandName'), detailValue: this.registrationDetails.distributor_name },
            { id: 11, detailKey: this.$t('modelName'), detailValue: this.registrationDetails.udi },
            { id: 12, detailKey: this.$t('productClass'), detailValue: this.registrationDetails.product_class }
          ];
        }
      }
    }
  },
};
</script>
<style scoped>
.view-record-header {
  padding: 24px 40px 17px 24px;
  background: #EBEBEB;
}
/* .cards-main {
  border: 1px solid #b3b3b3;
} */
.pt-10 {
  padding-top: 9px
}
.p-40 {
  padding: 40px
}

.product_name {
  color: #3E3E3E;
}

.certificate-heading {
  padding-left: 12px;
  margin-bottom: 12px;
}
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.view-details-main {
  /* height: calc(100vh - 50px) !important; */
  background: #F5F5F5;
}

.content-wrappper {
  background: #F5F5F5;
}

.status-card {
  background-color: #fff;
  border: 1px solid #b3b3b3;
  margin-bottom: 25px;
  padding: 16px 48px 31px 16px;
}

.product-details {
  background-color: #fff;
}

.status-font {
  color: #3E3E3E;
  font-size: 24px;
  font-weight: 400;
}

.note-font {
  color: #3E3E3E;
  font-size: 16px;
  font-weight: 400;
}

.col-gap-12 {
  column-gap: 12px;
}

.h-100 {
  min-height: 100vh;
}</style>
